import { useFileManagerStore, type FileManagerViewMode } from "@/state/fileManagerStore";

const OPTIONS: { value: FileManagerViewMode; label: string }[] = [
  { value: "grid", label: "Grid" },
  { value: "list", label: "Lista" },
];

export function ViewModeToggle() {
  const viewMode = useFileManagerStore((state) => state.viewMode);
  const setViewMode = useFileManagerStore((state) => state.setViewMode);

  return (
    <div className="flex rounded border border-ink-700 bg-ink-900 p-0.5" aria-label="Modo de visualização">
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => setViewMode(option.value)}
          className={`rounded px-2 py-1 text-xs ${
            viewMode === option.value ? "bg-ink-700 text-ink-100" : "text-ink-400 hover:text-ink-100"
          }`}
          aria-pressed={viewMode === option.value}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
